import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { ButtonTypeEnum } from '@panaya/ui/p-button';
import { KeyboardService } from '../../keyboard';

@Component({
    selector: 'p-chip-group',
    template: `
        <div class="p-hashtag-bar" [class.edit-mode]="!isReadonly && displayRemoveIcon" [ngClass]="{ 'p-long-bar': isSmallChip }">
            <ul class="p-hashtag-list">
                <li class="p-hashtag-item" *ngFor="let chip of list; let i = index" [ngClass]="{ 'p-small-chip': isSmallChip }">
                    <p-chip
                        *ngIf="!!(icon && icon(chip))"
                        [icon]="icon(chip).icon"
                        [label]="icon(chip).name"
                        [iconRemove]="!isReadonly && displayRemoveIcon"
                        (onRemove)="remove($event, chip)"
                    ></p-chip>
                    <p-chip
                        *ngIf="!icon || !icon(chip)"
                        [label]="chip[nameField] || chip"
                        [iconRemove]="!isReadonly && displayRemoveIcon"
                        (onRemove)="remove($event, chip)"
                    ></p-chip>
                </li>
            </ul>

            <p-button
                *ngIf="!isReadonly"
                class="p-hashtag-icon"
                iconBefore="chevron-down"
                [buttonType]="buttonType"
                (keydown)="onKeydownEvent($event)"
            ></p-button>
        </div>
    `,
    styleUrls: ['./p-chip-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PChipGroupComponent implements OnInit {
    @Input() tabIndex = -1;
    @Input() list: any[] = [];
    @Input() isReadonly = false;
    @Input() displayRemoveIcon = true;
    @Input() nameField = 'name';
    @Input() icon?: (t: any) => any;
    @Input() isSmallChip = false;

    @Output() keyBoardClicked: EventEmitter<any> = new EventEmitter();
    @Output() removeItem: EventEmitter<any> = new EventEmitter();

    buttonType = ButtonTypeEnum.IsIcon;

    constructor(private keyboardService: KeyboardService) {}

    ngOnInit(): void {}

    remove(event: Event, chip: any): void {
        event.stopPropagation();
        this.removeItem.emit(chip);
    }

    onKeydownEvent(e: KeyboardEvent) {
        const code = e.keyCode;

        if (this.keyboardService.isDown(code) || this.keyboardService.isEnter(code)) {
            this.keyBoardClicked?.emit();
        }
    }
}
